import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { DollarSign, Search } from "lucide-react";
import "../styles/Admin.css";
import { getAllPayments } from "../ServiceAPI/AdminUser/paymentApi";

const PaymentsPage = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const data = await getAllPayments();
      if (Array.isArray(data)) {
        setPayments(data);
      } else if (Array.isArray(data.payments)) {
        setPayments(data.payments);
      } else if (Array.isArray(data.data)) {
        setPayments(data.data);
      } else {
        setPayments([]);
      }
    } catch (err) {
      console.error("Error fetching payments:", err);
      setPayments([]);
    } finally {
      setLoading(false);
    }
  };

  // Check authentication
  useEffect(() => {
    const isAdminAuthenticated = localStorage.getItem("adminAuth") === "true";
    if (!isAdminAuthenticated) {
      navigate("/admin/login");
      return;
    }
    fetchPayments();
  }, [navigate]);

  const filteredPayments = payments.filter((payment) => {
    const q = searchTerm.toLowerCase();
    if (!q) return true;
    return (
      String(payment.PaymentId || "").toLowerCase().includes(q) ||
      String(payment.ApplicationId || "").toLowerCase().includes(q) ||
      String(payment.Username || "").toLowerCase().includes(q) ||
      String(payment.Phone || "").toLowerCase().includes(q) ||
      String(payment.TransactionId || "").toLowerCase().includes(q) ||
      String(payment.UtrNumber || "").toLowerCase().includes(q) ||
      String(payment.PaymentStatus || "").toLowerCase().includes(q)
    );
  });

  if (loading) {
    return (
      <AdminLayout>
        <div className="loading-container">
          <div className="spinner-large"></div>
          <p>Loading payments...</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Payments</h1>
          <p className="admin-page-subtitle">View payment history and transactions</p>
        </div>
      </div>

      <div className="admin-content-area">
        <div className="data-table-card">
          <div className="data-table-header">
            <h3>Recent Payments ({filteredPayments.length} of {payments.length})</h3>
          </div>
          <div className="search-filter-section">
            <div className="search-box">
              <Search size={20} />
              <input
                type="text"
                placeholder="Search by payment/application/user/txn/status..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          {filteredPayments.length > 0 ? (
            <div className="table-responsive">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Payment ID</th>
                    <th>Application ID</th>
                    <th>User</th>
                    <th>Phone</th>
                    <th>Service</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Transaction ID</th>
                    <th>UTR</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPayments.map((payment, index) => (
                    <tr key={payment.PaymentId || index}>
                      <td><span className="td-badge">{payment.PaymentId}</span></td>
                      <td>{payment.ApplicationId}</td>
                      <td>{payment.Username || "N/A"}</td>
                      <td>{payment.Phone || "N/A"}</td>
                      <td>{payment.ServiceName || "N/A"}</td>
                      <td>INR {Number(payment.Amount || 0).toFixed(2)}</td>
                      <td>{payment.PaymentMethod || "N/A"}</td>
                      <td>{payment.TransactionId || "N/A"}</td>
                      <td>{payment.UtrNumber || "N/A"}</td>
                      <td>
                        <span className={`status-badge-modern ${String(payment.PaymentStatus || "pending").toLowerCase()}`}>
                          {payment.PaymentStatus || "PENDING"}
                        </span>
                      </td>
                      <td>{payment.PaymentDate ? new Date(payment.PaymentDate).toLocaleString() : "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state">
              <DollarSign size={48} />
              <p>No payment records available.</p>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default PaymentsPage;
